import { z } from 'zod';

const DATE_RE = /^\d{4}-\d{2}-\d{2}$/;

export const rezeptInvoicePrintOptionsSchema = z
  .object({
    print_receipt: z.boolean().default(false),
    print_invoice: z.boolean().default(false),
    print_receipt_invoice: z.boolean().default(false),

    print_type: z.union([z.literal(1), z.literal(2), z.literal(3)]).nullable().default(null),

    print_receipt_100_sub1: z.boolean().default(false),
    print_receipt_100_sub2: z.boolean().default(false),
    print_receipt_100_sub3: z.boolean().default(false),

    option_1: z.boolean().default(true),
    option_2: z.boolean().default(true),
    option_3: z.boolean().default(false),
    option_4: z.boolean().default(false),
    option_5: z.boolean().default(false),
    option_6: z.boolean().default(false),
    option_7: z.boolean().default(false),
    option_8: z.boolean().default(false),
    option_9: z.boolean().default(false),
    option_11: z.boolean().default(false),

    option_date: z
      .string()
      .optional()
      .or(z.literal(''))
      .transform(v => (v ? v : undefined)),
  })
  .superRefine((v, ctx) => {
    if (!v.print_receipt && !v.print_invoice && !v.print_receipt_invoice) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['print_receipt'],
        message: '出力帳票を選択してください。',
      });
    }
    if (v.print_type == null) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['print_type'],
        message: '用紙サイズを選択してください。',
      });
    }
    // option_date is optional even when option_5 is checked: when missing the
    // BE renders a blank template (元号　年　月　日). Only validate format when a
    // date is actually provided.
    if (v.option_5 && v.option_date && !DATE_RE.test(v.option_date)) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['option_date'],
        message: '日付を正しく入力してください。',
      });
    }
  });

export type RezeptInvoicePrintOptionsFormValues = z.infer<typeof rezeptInvoicePrintOptionsSchema>;

export const DEFAULT_PRINT_OPTIONS: RezeptInvoicePrintOptionsFormValues = {
  print_receipt: false,
  print_invoice: false,
  print_receipt_invoice: false,
  print_type: null,
  print_receipt_100_sub1: false,
  print_receipt_100_sub2: false,
  print_receipt_100_sub3: false,
  option_1: true,
  option_2: true,
  option_3: false,
  option_4: false,
  option_5: false,
  option_6: false,
  option_7: false,
  option_8: false,
  option_9: false,
  option_11: false,
  option_date: undefined,
};

export function getDefaultPrintOptions(
  searchTermType?: 1 | 2
): RezeptInvoicePrintOptionsFormValues {
  return {
    ...DEFAULT_PRINT_OPTIONS,
    option_6: searchTermType === 2,
    option_9: searchTermType === 1,
  };
}
